import React, { useEffect, useState, useMemo, Fragment } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl/dist';
import { createStructuredSelector } from 'reselect';

import YearSelect from '../../../components/common/yearSelect/YearSelect';
import ApplicationPanel from '../../../components/individualPortal/applications/ApplicationPanel';
import AlertMessage from '../../../components/individualPortal/dashboard/AlertMsgs/AlertMessage';

import { getApplications } from '../../../actions/individualPortal/applications/applicationsActionCreators';
import { getEnvironment, showModal } from '../../../actions/common/actionCreators';
import { cancelApp } from '../../../actions/individualPortal/dashboard/dashboardActionCreators';
import { loadedSelector, sortedApplicationsSelector, householdCaseIdSelector } from '../../../selectors/applicationsSelectors';
import { environmentSelector } from '../../../selectors/commonSelectors';
import { dashboardModalTypes } from '../../../constants/individualPortal/dashboard/modals/dashboardModalTypes';
import { configs } from '../../../constants/configs/configs';
import { getYearDropDownOptions } from '../utils/application-container-utils';


const ApplicationContainer = (props) => {

    const {
        history,
        environment: {
            stateCode,
            isState,
            coverageYear,
            exchangeStartYear,
            exchangeName,
            language,
            stateSubsidyEnabled,
            links: {
                CALHEERS_URL
            },
            localDates: {
                serverDate,
                oepStartDate
            },
            flags:{
                isQleMultipleDocumentSupport
            }
        },
        loaded,
        applications,
        householdCaseId,
        getApplications,
        getEnvironment,
        cancelApp,
        showModal
    } = props;

    const yearsDropDownOptions = useMemo(
        () => getYearDropDownOptions(serverDate, oepStartDate, coverageYear, exchangeStartYear),
        [exchangeStartYear, coverageYear]
    );

    const lastYear = useMemo(
        () => {
            const lastYearFromOptions = [ ...yearsDropDownOptions ].pop();
            return lastYearFromOptions ? lastYearFromOptions : exchangeStartYear;
        },
        [ yearsDropDownOptions ]
    );

    const [selectedYear, setSelectedYear] = useState(lastYear);

    useEffect(() => {
        getEnvironment();
    }, []);

    useEffect(() => {
        getApplications(selectedYear);
    }, [selectedYear]);

    const latestApp = (applications && applications.currentApps[0] && applications.currentApps[0].caseNumber) ||
        (applications && applications.pastApps[0] && applications.pastApps[0].caseNumber);


    const getSectionHeader = (sectionName, year) => {
        const CURRENT_APPS = 'currentApps';
        const PAST_APPS = 'pastApps';

        switch (sectionName) {
            case CURRENT_APPS:
                return <FormattedMessage id='applications.current_app' values={{ year }}/>;
            case PAST_APPS:
                return <FormattedMessage id='applications.past_app' values={{ year }}/>;
        }
    };

    const historicalApp = selectedYear !== lastYear;

    const onCancelApp = (caseNumber) => {
        showModal({
            modalType: dashboardModalTypes.CANCEL_APP_MODAL,
            modalData: { cb:  cancelApp.bind(null, configs.endpoints.CANCEL_APP, { caseNumber })
            }
        });
    };

    return (
        loaded ?
            <div id="applications" className="usa-layout-docs gi-main-section applications">
                <YearSelect
                    msgId="applications.year_dropdown.heading"
                    years={yearsDropDownOptions}
                    initialYear={lastYear}
                    onChangeHandler={(selectedYear) => setSelectedYear(selectedYear)}
                />
                {
                    applications ?
                        <Fragment>
                            { historicalApp &&
                            <AlertMessage
                                content={<FormattedMessage id='applications.alert' values={{ currentYear: lastYear }}/>}
                                type='warning'/>
                            }
                            {
                                Object.keys(applications).map(section => {
                                    if (applications[section].length > 0) {
                                        return <div className="application__section" key={section}>
                                            {
                                                !historicalApp &&
                                                <h2 className='application__section__header'>{getSectionHeader(section, lastYear)}</h2>
                                            }
                                            {
                                                applications[section].map((application) =>
                                                    <ApplicationPanel
                                                        key={application.caseNumber}
                                                        latestApp={latestApp === application.caseNumber}
                                                        appPanelData={{ ...application, householdCaseId }}
                                                        envData={{ stateCode, isState, CALHEERS_URL, language, stateSubsidyEnabled, isQleMultipleDocumentSupport }}
                                                        history={history}
                                                        onCancelApp={onCancelApp}
                                                    />
                                                )
                                            }
                                        </div>;
                                    }

                                })
                            }
                        </Fragment> :
                        <p className='gi-panel gi-application-panel application'>
                            <FormattedMessage id='applications.no_app' values={{ exchangeName }}/>
                        </p>

                }

            </div> : null
    );
};

const mapStateToProps = createStructuredSelector({
    environment: environmentSelector,
    loaded: loadedSelector,
    householdCaseId: householdCaseIdSelector,
    applications: sortedApplicationsSelector
});

export default connect(mapStateToProps, { getApplications, getEnvironment, cancelApp, showModal })(ApplicationContainer);